import styled, { css } from 'styled-components';
import { Color } from '../../common/base';

const HiwList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const HiwListItem = styled.li`
  padding: 8px 0;
  position: relative;
  white-space: pre-wrap;
`;

const HiwListItemCount = styled.div`
  display: inline-flex;
  width: 24px;
  height: 24px;
  background-color: ${Color.redMediumDark};
  color: ${Color.white};
  justify-content: center;
  align-items: center;
  font-size: 14px;
  border-radius: 100px;
  line-height: 0;
  position: absolute;
  ${props => props.orange && css`
    background-color: ${Color.orange};
  `}
`;

const HiwListItemDesc = styled.div`
  display: inline-block;
  padding-left: 36px;
`;

export {
  HiwList, HiwListItem, HiwListItemCount, HiwListItemDesc,
};
